/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OrganizationNameConfig_formValues = {
    readonly organization: {
        readonly name: string;
    };
    readonly " $refType": "OrganizationNameConfig_formValues";
};
export type OrganizationNameConfig_formValues$data = OrganizationNameConfig_formValues;
export type OrganizationNameConfig_formValues$key = {
    readonly " $data"?: OrganizationNameConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"OrganizationNameConfig_formValues">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationNameConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '11f97b12364a666f048130db9496265f';
export default node;
